// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".helper-overlay[data-v-d4ce4b98]{background:#f5f5f5;border:3px solid #3662ad;border-radius:5px;height:95vh;opacity:.5;padding:10px;position:fixed;right:2vw;top:2vh;width:95vw;z-index:999}.helper-overlay[data-v-d4ce4b98]:hover{opacity:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
